export default __webpack_public_path__ + "static/media/13-SunLife-Logo.c8bc52a6.jpg";